import { Link2 } from 'lucide-react'
import type { GroundedEntity } from '@ispot/shared'

interface GroundingChipListProps {
  entities: GroundedEntity[]
  maxVisible?: number
}

export function GroundingChipList({ entities, maxVisible = 3 }: GroundingChipListProps) {
  if (!entities || entities.length === 0) {
    return (
      <span
        className="inline-flex items-center gap-1 text-[10px]"
        style={{ color: 'var(--color-text-muted)' }}
      >
        <Link2 className="h-2.5 w-2.5" />
        No grounding
      </span>
    )
  }

  const visible = entities.slice(0, maxVisible)
  const overflow = entities.length - visible.length

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <Link2
        className="h-3 w-3 shrink-0"
        style={{ color: 'var(--color-text-muted)' }}
      />
      {visible.map((e) => (
        <span
          key={e.uri}
          className="inline-flex items-center gap-1 rounded px-2 py-0.5 text-[10px]"
          style={{
            backgroundColor: 'var(--color-warm-100)',
            color: 'var(--color-text-secondary)',
          }}
          title={`${e.type}: ${e.uri}`}
        >
          <span className="font-medium">{e.type}</span>
          <span>·</span>
          <span>{e.label}</span>
        </span>
      ))}
      {overflow > 0 ? (
        <span
          className="text-[10px]"
          style={{ color: 'var(--color-text-muted)' }}
        >
          +{overflow} more
        </span>
      ) : null}
    </div>
  )
}
